import type { LocationQuery } from 'vue-router';
import type { AnyObject } from '@eurzad/design-system';

import { LogoutType, Session } from 'shared/clients/client-spa-AccountGroup';

export type Action = (payload?: AnyObject) => Promise<void>;

export interface MessageConfig {
  messageType: MESSAGE_TYPE;
  destinationApp: DESTINATION_APP_TYPE;
  action: (payload: MessagePayloadMapByMessageTypeUnion, eventMessage: MessageEvent<MessageData>) => Promise<void>;
}

export interface MessageData {
  messageType: MESSAGE_TYPE,
  destinationApp: DESTINATION_APP_TYPE
  payload: MessagePayloadMapByMessageTypeUnion;
}

export enum MESSAGE_TYPE {
  REDIRECT = 'redirect',
  WEB_INITIALIZED = 'webInitialized',
  REFRESH_TOKEN_INJECTION = 'refreshTokenInjection',
  TOKEN_AND_LANGUAGE_INJECTION = 'tokenAndLanguageInjection',
  MOBILE_LANGUAGE_INJECTION = 'mobileLanguageInjection',
  LANGUAGE_INJECTION = 'languageInjection',
  LOGOUT = 'logout',
  TOKEN_INJECTION = 'tokenInjection',
  LOGOUT_FROM_MOBILE_APP = 'logoutFromMobileApp',
  MOBILE_CHECK_SESSION = 'mobileCheckSession',
}

export enum DESTINATION_APP_TYPE {
  HOST = 'host',
  E_DECLARATIONS = 'eDeclarations',
  E_DECLARATIONS_PARENT = 'eDeclarationsParent',
  MOBILE = 'mobile',
  ROUTE_ROOT = 'routeRoot',
}

export interface MobileCheckSession extends Session {
  appVersion: string;
}

type MessageTypeMapByDestinationAppType = {
  [DESTINATION_APP_TYPE.E_DECLARATIONS]: MESSAGE_TYPE.REDIRECT;
  [DESTINATION_APP_TYPE.E_DECLARATIONS_PARENT]: MESSAGE_TYPE.REDIRECT;
  [DESTINATION_APP_TYPE.HOST]:
    MESSAGE_TYPE.TOKEN_AND_LANGUAGE_INJECTION |
    MESSAGE_TYPE.LOGOUT |
    MESSAGE_TYPE.LANGUAGE_INJECTION |
    MESSAGE_TYPE.MOBILE_LANGUAGE_INJECTION |
    MESSAGE_TYPE.REFRESH_TOKEN_INJECTION |
    MESSAGE_TYPE.TOKEN_INJECTION |
    MESSAGE_TYPE.LOGOUT_FROM_MOBILE_APP |
    MESSAGE_TYPE.MOBILE_CHECK_SESSION;
  [DESTINATION_APP_TYPE.MOBILE]: MESSAGE_TYPE.WEB_INITIALIZED;
  [DESTINATION_APP_TYPE.ROUTE_ROOT]: MESSAGE_TYPE.REDIRECT;
}

export type ValidMessageType<T extends DESTINATION_APP_TYPE> = MessageTypeMapByDestinationAppType[T];

export type MessagePayloadMapByMessageType = {
  [MESSAGE_TYPE.REDIRECT]: { redirectUrl: string; query?: LocationQuery; };
  [MESSAGE_TYPE.WEB_INITIALIZED]: null | undefined;
  [MESSAGE_TYPE.TOKEN_AND_LANGUAGE_INJECTION]: { token: string, language: string };
  [MESSAGE_TYPE.MOBILE_LANGUAGE_INJECTION]: string;
  [MESSAGE_TYPE.LANGUAGE_INJECTION]: { language: string, omitUpdateUserLang: boolean };
  [MESSAGE_TYPE.LOGOUT]: LogoutType;
  [MESSAGE_TYPE.REFRESH_TOKEN_INJECTION]: string;
  [MESSAGE_TYPE.TOKEN_INJECTION]: string;
  [MESSAGE_TYPE.LOGOUT_FROM_MOBILE_APP]: null | undefined;
  [MESSAGE_TYPE.MOBILE_CHECK_SESSION]: MobileCheckSession;
}

export type MessagePayloadMapByMessageTypeUnion = MessagePayloadMapByMessageType[keyof MessagePayloadMapByMessageType];

export type MessagePayload<T extends MESSAGE_TYPE> = MessagePayloadMapByMessageType[T];